import React, { useContext } from 'react';
import './UnitPriceCellRenderer.scss';
import { AuthContext } from '../../context/UserContext';
import { getLangSite } from '../../ultils'
import { useTranslation } from 'react-i18next';

export const UnitPriceTariffCellRenderer: React.FC = (props: any) => {
  const { data } = props;
  const { userData } = useContext(AuthContext);
  const { t } = useTranslation();
  let isShowMessage = false;
  
  //Handling render box cell in first row for reverse table
  if (data.typeColumn && data.typeColumn === 'first-row') {
    return null;
  }

  //Handling render box cell in second row for reverse table
  if (data.typeColumn && data.typeColumn === 'second-row') {
    return null;
  }
  
  return (
    <div className="unit_price_container">
      {(getLangSite('us').site === 'us' && data.productVariations) &&
        // Sort by quantity ASC
        data.productVariations.sort((a: any, b: any) => {
          // Check exists
          if (
            a.priceBreaksIncludeTariff &&
            a.priceBreaksIncludeTariff.length > 0 &&
            a.priceBreaksIncludeTariff[0].quantity &&
            b.priceBreaksIncludeTariff &&
            b.priceBreaksIncludeTariff.length > 0 &&
            b.priceBreaksIncludeTariff[0].quantity
          ) {
            return a.priceBreaksIncludeTariff[0].quantity >
              b.priceBreaksIncludeTariff[0].quantity
              ? 1
              : -1;
          }
        }) &&
        data.productVariations.map((item: any, index: number) => {
          const priceBreaksIncludeTariff = item?.priceBreaksIncludeTariff;
          const packageType = item?.packageType?.name;

          if (
            packageType &&
            !packageType.includes('Digi-Reel') &&
            priceBreaksIncludeTariff
          ) {
            const price = priceBreaksIncludeTariff[0]?.price.toFixed(
              Math.max(
                5,
                (
                  priceBreaksIncludeTariff[0]?.price.toString().split('.')[1] ||
                  []
                ).length
              )
            );
            const quantity = priceBreaksIncludeTariff[0]?.quantity;
            
            if (price && quantity && userData.IsLoggedIn) {
              return (
                <div className="unit_price_break" key={index}>
                  <div>
                    <span>{quantity}: </span>
                    <span className="unit_price_price">
                      ${priceBreaksIncludeTariff[0]?.price.toFixed(
                        Math.max(
                          5,
                          (
                            priceBreaksIncludeTariff[0].price
                              .toString()
                              .split('.')[1] || []
                          ).length
                        )
                      )}
                    </span>
                  </div>
                  <div className="unit_price_package">{packageType}</div>
                </div>
              );
            } else {
                if(data.crossType.type === "Source Part" && price && quantity){
                  return (
                    <div className="unit_price_break" key={index}>
                    <div>
                      <span>{quantity}: </span>
                      <span className="unit_price_price">
                        ${priceBreaksIncludeTariff[0]?.price.toFixed(
                          Math.max(
                            5,
                            (
                              priceBreaksIncludeTariff[0].price
                                .toString()
                                .split('.')[1] || []
                            ).length
                          )
                        )}
                      </span>
                    </div>
                    <div className="unit_price_package">{packageType}</div>
                  </div>
                  )
                } 
                if(data.crossType.type !== "Source Part" && price && quantity && !isShowMessage){
                  isShowMessage = true
                  return (
                    <div>
                      <span>
                        {t('xref-tb-tariff-may-apply')}
                      </span>
                    </div>
                  )
                }
            }
          }
        })}
    </div>
  );
};
